import { MortgageDocumentsWorkspace } from './MortgageDocumentsWorkspace';

export function ProfileMortgageApplicationPanel() {
  return <MortgageDocumentsWorkspace variant="page" />;
}
